import { render, staticRenderFns } from "./academic-for-no-enroll.vue?vue&type=template&id=693159a8&"
import script from "./academic-for-no-enroll.vue?vue&type=script&lang=js&"
export * from "./academic-for-no-enroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports